// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c4395551","732":"c9d8aac3","977":"0e1347b8"}[chunkId] + ".chunk.js";
};